import { render, staticRenderFns } from "./ContentInclusiveSection.vue?vue&type=template&id=12864ca3"
import script from "./ContentInclusiveSection.vue?vue&type=script&lang=ts"
export * from "./ContentInclusiveSection.vue?vue&type=script&lang=ts"
import style0 from "./ContentInclusiveSection.vue?vue&type=style&index=0&id=12864ca3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports